import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Typeahead, TimePicker,
    cellEditFactory ,moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, Container, Modal, DatePicker,Dropdown, DropdownButton, props
} 
from '../../../noser-hris-component';


class ProcessBillingModal extends Component {
    constructor(props) {
        super(props)
        this.state ={
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,

            invoiceNo       :   '',
            clientName      :   '',
            clientId        :   '',
            locationName    :   '',
            period          :   '',
            payOutDate      :   '',
            date            :   '',
        }
    }

    componentDidMount(){
        /* this.setState({isLoading:true,loadingText:"Loading client list..."}) */
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.props.onRefProcessBilling(this)
    }

    componentWillUnmount() {
        this.props.onRefProcessBilling()
    }
    
    initialize = (e) => {
        this.setState({
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,

            invoiceNo       :   '',
            clientName      :   e.clientNameFromParent,
            clientId        :   e.clientIdFromParent,
            locationName    :   e.locationFromParent,
            period          :   e.periodFromParent,
            payOutDate      :   e.payOutDateFromParent,
            date            :   e.dateFromParent,
        })
    }

    onModalClose = () => {
        this.props.onHide();
    }

    onChangeInvoiceNo = (e) => {
        this.setState({ invoiceNo: e.target.value} );
    }
    render() {


    return(
        
            <Modal
                {...this.props}
                return
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        UNBILLED (Process Billing)
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                <div className={this.state.color}></div> 
                                {this.state.message}
                            </Alert>
                            <Form.Row>
                                <Form.Group as={Col} sm={12} controlId="formGridEmail">
                                <h4>
                                    Client
                                </h4>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} sm={2} controlId="formGridPassword">
                                    <Form.Label style={{color: '#2188FC', fontWeight: 'bold'}}>
                                        Branch / Area
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Col} sm={1} controlId="formGridPassword">
                                :
                                </Form.Group>
                                <Form.Group as={Col} sm={3} controlId="formGridPassword">
                                    <Form.Label style={{color: 'red'}}>
                                        { this.state.locationName }
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} sm={2} controlId="formGridPassword" style={{color: '#2188FC', fontWeight: 'bold'}}>
                                    <Form.Label>
                                        Period
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Col} sm={1} controlId="formGridPassword">
                                :
                                </Form.Group>
                                <Form.Group as={Col} sm={3} controlId="formGridPassword">
                                    <Form.Label style={{color: 'red'}}>
                                        { this.state.period }
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} sm={2} controlId="formGridPassword" style={{color: '#2188FC', fontWeight: 'bold'}}>
                                    <Form.Label>
                                    Pay Out
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Col} sm={1} controlId="formGridPassword">
                                :
                                </Form.Group>
                                <Form.Group as={Col} sm={3} controlId="formGridPassword">
                                    <Form.Label style={{color: 'red'}}>
                                        { this.state.payOutDate }
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} sm={2} controlId="formGridPassword" style={{color: '#2188FC', fontWeight: 'bold'}}>
                                    <Form.Label>
                                        Date (current)
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Col} sm={1} controlId="formGridPassword">
                                :
                                </Form.Group>
                                <Form.Group as={Col} sm={3} controlId="formGridPassword">
                                    <Form.Label style={{color: 'red'}}>
                                        { this.state.date }
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>


                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="3">
                                    Enter Serving Invoice No.
                                </Form.Label>
                                <Col sm="4">
                                    <Form.Control 
                                        type="text"
                                        ref="invoiceNo"
                                        autoComplete="off" 
                                        name="payDay"
                                        value={this.state.invoiceNo}
                                        onChange={this.onChangeInvoiceNo}
                                    />
                                </Col>
                                <Col sm="4">
                                    <Button variant="success" className="ml-auto">
                                        GENERATE BILLING
                                    </Button>
                                </Col>
                            </Form.Group>

                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar >
                        <Button variant="info" className="ml-auto">
                            EDIT
                        </Button>&nbsp;&nbsp;
                        <Button variant="success">
                            FINALIZED BILLING
                        </Button>&nbsp;&nbsp;
                        <Button variant="danger" onClick={this.onModalClose}>
                            Close
                        </Button>
                    </ButtonToolbar>
            </Modal.Footer>
                <NoserLoading show={this.state.isloading} />
        </Modal>
        );
    }

}
export  default ProcessBillingModal